export default __webpack_public_path__ + "locales/zh-CN/ChangePasswordDialog.json?hash=5a1b0670cf5889afe08633e68d42e02a";